import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Select } from '@ipc/ipc-components';

import { PanelContent } from '../../../styles';
import { FormLabel, Checkbox } from '../../../elements';
import { ALA_LEVELS_OPTIONS_WITHOUT_ALL, ALL_ALA_LEVELS_LABEL } from '../../../utils/constants';

const AutomaticAlaApprovalComponent = ({
  values, validations, selectChangeHandler, checkboxChangeHandler,
}) => {
  const getLabel = (item) => {
    if (item && item.label) {
      return typeof item.label === 'string' && item.label.includes('ALA') ? item.label : `ALA${item.value}`;
    }
    return null;
  };

  const getLabelValueForSelectValue = () => ({
    label: getLabel(values.autoApprovalAlaLevel),
    value: values.autoApprovalAlaLevel ? values.autoApprovalAlaLevel.value : '',
  });

  const autoApprovalCheckboxHandler = (event, value) => {
    if (!value) {
      values.autoApprovalAlaLevel = [];
    }
    checkboxChangeHandler(event, value);
  };

  const getAlaLevelOptions = () => {
    if (values.alaLevels && values.alaLevels.some(alaLevel => alaLevel.label === ALL_ALA_LEVELS_LABEL)) {
      return ALA_LEVELS_OPTIONS_WITHOUT_ALL;
    }
    return values.alaLevels;
  };

  return (
    <Panel title="Automatic ALA Approval" expanded>
      <PanelContent>
        <div className="FormRow">
          <div className="FormRowInline">
            <Checkbox
              name="autoApprovalOn"
              checked={!!values.autoApprovalOn}
              onChange={autoApprovalCheckboxHandler}
              label="Automatic Approval On"
            />
          </div>

          {values.autoApprovalOn && (
            <div className="FormRowInline">
              <FormLabel
                title="Set Auto Approval threshold (Selected and lower numbered ALA levels are automatically approved)"
                required
                hasError={!validations.autoApprovalAlaLevel}
              >
                <Select
                  name="autoApprovalAlaLevel"
                  options={getAlaLevelOptions()}
                  value={getLabelValueForSelectValue()}
                  onChange={selectChangeHandler}
                  className="Input SingleSelect"
                />
              </FormLabel>
            </div>
          )}
        </div>
      </PanelContent>
    </Panel>
  );
};

AutomaticAlaApprovalComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  selectChangeHandler: PropTypes.func,
  checkboxChangeHandler: PropTypes.func,
};

export default AutomaticAlaApprovalComponent;
